import { graphql, useStaticQuery } from "gatsby"
import React, { useEffect, useState } from "react"
import formatNumber from "../../../../shared/utils/formatNumber"
import AuthService from "../../../services/auth-service"
import { siteUrl } from "../../../utils/siteUrl"
import Button from "../../atoms/button/button"
import TitleTab from "../../atoms/title-tab/title-tab"
import OtpModal from "../../modals/otp-modal/otp-modal"
import ChangeAddress from "../change-address/change-address"
import EditPictureModal from "../edit-picture-modal/edit-picture-modal"
import RestorePasswordModal from "../restore-password-modal/restore-password-modal"
import StandardModal from "../standard-modal/standard-modal"
import validCellphonePY from "../../../utils/validCellPhonePY"
import "./profile-modal.scss"

const ProfileModal = props => {
  const { setCommondModal, logout, setInfoUser } = props

  const resultQuery = useStaticQuery(
    graphql`
      query ADRESS_QUERY {
        allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
          nodes {
            node_locale
            codigoIcu
            titulo
            tieneMisPuntos
            departamentos {
              codigo
              nombre
            }
            ciudades {
              codigo
              codigoDepartamento
              nombre
            }
          }
        }
      }
    `
  )
  const havePoints = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0].tieneMisPuntos
  const [modalChangeAdress, setModalChangeAdress] = useState(null)

  const [isLoaded, setisLoaded] = useState(false)
  const [mobile, setmobile] = useState(false)
  // const [userInfo, setuserInfo] = useState(null)
  const [showingEditPicture, setshowingEditPicture] = useState(false)

  var userInfo = JSON.parse(localStorage.getItem("USER_INFO"))

  useEffect(() => {
    var body = document.getElementsByTagName("body")[0]
    var html = document.getElementsByTagName("html")[0]
    body.classList.add("overflow-body-hidden")
    html.classList.add("overflow-body-hidden")

    setisLoaded(true)
    setmobile(window.innerWidth < 1024 ? true : false)
  }, [])

  const handleCloseModal = () => {
    var body = document.getElementsByTagName("body")[0]
    var html = document.getElementsByTagName("html")[0]
    body.classList.remove("overflow-body-hidden")
    html.classList.remove("overflow-body-hidden")
    setisLoaded(false)

    setTimeout(() => {
      setCommondModal(null)
    }, 600)
  }

  const getNoPrefix = num => {
    return num.slice(
      process.env.COUNTRY_PHONE_PREFIX.length,
      userInfo.cellPhone.length
    )
  }

  const handleCloseSession = () => {
    handleCloseModal()

    setTimeout(() => {
      logout()
    }, 200)
  }

  var ciudades = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0].ciudades
  var departamentos = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0].departamentos

  /* ------- Inputs values ------- */
  const [despartamentoSelected, setdespartamentoSelected] = useState(
    userInfo.location ? userInfo.location.countryState.toString() : ""
  )
  const [ciudadSelected, setciudadSelected] = useState(
    userInfo.location ? userInfo.location.city.toString() : ""
  )
  const [nameValue, setnameValue] = useState(userInfo.name)
  const [lastnameValue, setlastnameValue] = useState(userInfo.lastName)
  const [phoneValue, setphoneValue] = useState(
    userInfo.cellPhone !== null
      ? validCellphonePY(getNoPrefix(userInfo.cellPhone))
      : null
  )
  const [mailValue, setmailValue] = useState(userInfo.email)
  const [addressValue, setaddressValue] = useState(
    userInfo.location ? userInfo.location.address : ""
  )
  const [addressDetailValue, setaddressDetailValue] = useState(
    userInfo.location ? userInfo.location.addressDetail : ""
  )
  const [birthdateValue, setbirthdateValue] = useState(
    userInfo.birthdate.split(" ")[0]
  )

  /* ------- Inputs values ------- */

  /* ----- Error flags ----- */
  const [nameError, setnameError] = useState(false)
  const [lastnameError, setlastnameError] = useState(false)
  const [phoneError, setphoneError] = useState(false)
  const [addressError, setaddressError] = useState(false)
  const [phoneFormatError, setphoneFormatError] = useState(false)
  /* ----- Error flags ----- */

  const [disableButton, setdisableButton] = useState(false)

  const errorLabel = (
    <label className="f-input-label-error">*Campo requerido</label>
  )

  // const formatDate = date => {
  //     var d = date.split(' ')[0].split('-')
  //     return d[2] + '/' + d[1] + '/' + d[0]
  // }

  const handleSubmit = e => {
    e.preventDefault()

    if (!haveErrors()) {
      // setdisableButton(true)
      setModalChangeAdress(
        <OtpModal
          setCommondModal={setModalChangeAdress}
          nextFunct={nextToOTP}
        />
      )
    }
  }
  const nextToOTPChangePassword = inputValueOTPAux => {
    setModalChangeAdress(
      <RestorePasswordModal
        inputValueOTP={inputValueOTPAux}
        setCommondModal={setModalChangeAdress}
        resetPassword={true}
      />
    )
  }

  const nextToOTP = inputValueOTPAux => {
    var payload = {
      adult: userInfo.adult,
      // birthdate: formatDate(userInfo.birthdate),
      cellPhone: (phoneValue === "" || phoneValue === " " || phoneValue === null || phoneValue === undefined) ? null :
        process.env.COUNTRY_PHONE_PREFIX +
        (process.env.LOCALE === "es-PY"
          ? parseInt(phoneValue, 10).toString()
          : parseInt(phoneValue).toString()),
      codeDestination: userInfo.codeDestination,
      country: userInfo.country,
      location: {
        city: ciudadSelected,
        address: addressValue,
        addressDetail: addressDetailValue,
      },
      email: userInfo.email,
      lastName: lastnameValue,
      name: nameValue,
      profilePicture: userInfo.profilePicture,
      otp: inputValueOTPAux,
    }

    var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

    var config = {
      headers: {
        Authorization: tokenId,
      },
    }

    AuthService.updateAccount(payload, config)
      .then(res => {
        if (res.status === 200) {
          setdisableButton(false)
          setInfoUser(res.data)
          localStorage.setItem("USER_INFO", JSON.stringify(res.data))
          setCommondModal(
            <StandardModal
              title="¡Tus datos se han actualizado con éxito!"
              subtitle=""
              button_title={"Perfecto"}
              description="Tus datos han sido actualizados en nuestra base de datos."
              click={() => setCommondModal(null)}
            />
          )
        } else {
          setdisableButton(false)
          setCommondModal(
            <StandardModal
              title="¡Hubo un error!"
              subtitle=""
              button_title={"Perfecto"}
              description={
                res.status === 400 && res.errorCode === "DEM016"
                  ? res.userMessage
                  : "Tus datos no se pudieron actualizar, inténtalo más tarde."
              }
              click={() => setCommondModal(null)}
            />
          )
         
        }
      })
      .catch(e => console.log(e))
  }

  const mistakeCellByCountry = num => {
    return (
      num.toString().length < parseInt(process.env.MIN_DIGITS) ||
      num.toString().length > parseInt(process.env.MAX_DIGITS)
    )
  }

  const haveErrors = () => {
    if (nameValue === "" || nameValue === " ") {
      setnameError(true)
    } else {
      setnameError(false)
    }

    if (lastnameValue === "" || lastnameValue === " ") {
      setlastnameError(true)
    } else {
      setlastnameError(false)
    }

    if (phoneValue !== "" && phoneValue !== " " && phoneValue !== null && phoneValue !== undefined) {
      if (mistakeCellByCountry(phoneValue)) {
        setphoneFormatError(true)
        return true
      } else {
        setphoneFormatError(false)
      }
    }

    if (addressValue === " ") {
      setaddressError(true)
    } else {
      setaddressError(false)
    }

    return (
      nameValue === "" ||
      nameValue === " " ||
      lastnameError === "" || lastnameError === " " ||
      addressValue === " "
    )
  }

  var homeLink = siteUrl + "/"
  var mailLink = homeLink + "contactanos/#f-mail-change"
  var dateLink = homeLink + "contactanos/#f-date-change"

  const cityLabel =
    process.env.LOCALE === "es-PR"
      ? "Municipio"
      : process.env.LOCALE === "es-PE"
        ? "Distrito"
        : "Ciudad"

  const singleLabel =
    process.env.LOCALE === "es-EC" ||
      process.env.LOCALE === "es-AR" ||
      process.env.LOCALE === "es-DO" ||
      process.env.LOCALE === "es-UY"
      ? "Provincia"
      : process.env.LOCALE === "es-CL"
        ? "Región"
        : "Departamento"

  return (
    <div className={"f-modal-profile-curtain " + (isLoaded ? "showing" : "")}>
      {modalChangeAdress}
      <div className={"f-container-info " + (isLoaded ? "showing" : "")}>
        <span
          className="icon2-close f-close-icon"
          onClick={() => handleCloseModal()}
        />
        <div
          className="f-close-session-container"
          onClick={() => handleCloseSession()}
        >
          <label className="f-close-session-label">Cerrar sesión</label>
          <span className="f-icon icon-exit f-exit-icon" />
        </div>

        {showingEditPicture && (
          <EditPictureModal
            mobile={mobile}
            setshowingEditPicture={setshowingEditPicture}
            setInfoUser={setInfoUser}
          />
        )}

        <div className="f-main-info">
          <div
            className="f-profile-img-container"
            onClick={() => setshowingEditPicture(true)}
          >
            <div className="f-img-container">
              <img
                src={userInfo.profilePicture}
                alt="Imagen de perfil"
                className="f-profile-img"
              />
            </div>
            <div className="f-icon-container">
              <span className="f-icon icon2-camara" />
            </div>
          </div>
          <label className="f-name-label">
            {"¡Hola, " + userInfo.name + "!"}
          </label>
          {havePoints && (
            <>
              {mobile ? (
                <label className="f-points-label">
                  {formatNumber(
                    userInfo.userPoints.pointsAccumulation +
                    userInfo.userPoints.pointsPresent
                  )}{" "}
                  puntos disponibles
                </label>
              ) : (
                  <TitleTab
                    className="f-TitleTab f-TitleTab-pink nunito"
                    title={
                      formatNumber(
                        userInfo.userPoints.pointsAccumulation +
                        userInfo.userPoints.pointsPresent
                      ) + " puntos disponibles"
                    }
                  />
                )}
            </>
          )}
        </div>
        {havePoints && (
          <div className="f-points-section-container">
            <div className="f-detail-profile-container f-count-points">
              <label className="f-label-title f-count-points-label">
                Puntos por vencer este mes
              </label>
              <label className="f-count-points-label-num">
                {formatNumber(userInfo.userPoints.pointsToExpire)}
              </label>
            </div>
            <div className="f-detail-profile-container f-details-points">
              <label className="f-label-title f-details-points-label">
                Ver detalle de tus movimientos
              </label>
              <a
                href={homeLink + "mis-puntos/mis-movimientos/"}
                className="f-details-points-label-redirect"
              >
                Ver detalle
              </a>
            </div>
          </div>
        )}
        <div className="f-userinfo-container">
          <span className="f-fake-shadow" />

          <label className="f-section-title">Actualiza tus datos</label>

          <form className="f-user-form" onSubmit={handleSubmit}>
            <div className="f-input-group">
              <label className="f-input-label">NOMBRE</label>
              <input
                className="f-input-profile"
                type="text"
                value={nameValue}
                id="f-input-name-profile"
                onChange={e =>
                  setnameValue(e.target.value.replace(/ {2}/g, " "))
                }
              />

              {nameError && errorLabel}
            </div>
            <div className="f-input-group">
              <label className="f-input-label">APELLIDO</label>
              <input
                className="f-input-profile"
                type="text"
                value={lastnameValue}
                id="f-input-lastname-profile"
                onChange={e =>
                  setlastnameValue(e.target.value.replace(/ {2}/g, " "))
                }
              />

              {lastnameError && errorLabel}
            </div>
            <div className="f-input-group">
              <label className="f-input-label">CELULAR</label>
              <input
                className="f-input-profile"
                type="numeric"
                value={phoneValue}
                id="f-input-phone-profile"
                onChange={e =>
                  setphoneValue(
                    (e.target.value === "" || e.target.value === " " || e.target.value === null) ? null :
                      e.target.value
                        .slice(0, parseInt(process.env.MAX_DIGITS))
                        .replace(/ {2}/g, " ")
                  )
                }
              />
              {phoneError && errorLabel}
              {phoneFormatError && (
                <label className="f-input-label-error">*Número inválido</label>
              )}
            </div>
            <div className="f-input-group f-disabled-update">
              <label className="f-input-label">CORREO</label>
              <input
                className="f-input-profile"
                type="numeric"
                value={mailValue}
                id="f-input-mail-profile"
                onChange={e => setmailValue(e.target.value)}
              />
              <span className="f-icon-tooltip icon-alert">
                <span className="f-tooltip-mail-recovery mail-tooltip">
                  ¿Quieres cambiar tu correo?
                  <a className="f-contact-redirect" href={mailLink}>
                    {process.env.LOCALE === "es-AR" ||
                      process.env.LOCALE === "es-PY"
                      ? "Contactanos"
                      : "Contáctanos"}
                  </a>
                  <span className="f-tooltip-signal"></span>
                  <span className="f-tooltip-bridge" />
                </span>
              </span>
            </div>
            {process.env.LOCALE !== "es-PR" && (
              <div className="f-input-group">
                <label className="f-input-label">
                  {singleLabel.toUpperCase()}
                </label>
                <div className="f-select-container">
                  <select
                    className="f-input-profile"
                    id="f-input-state-profile"
                    value={despartamentoSelected}
                    onChange={e => setdespartamentoSelected(e.target.value)}
                  >
                    {/* <option value="" >Selecciona </option> */}
                    {departamentos.map((departamento, index) => {
                      return (
                        <option value={departamento.codigo} key={index}>
                          {departamento.nombre}
                        </option>
                      )
                    })}
                  </select>

                  <span className="icon-down icon-select"></span>
                </div>
              </div>
            )}
            {process.env.LOCALE === "es-PR" ? (
              <div className="f-input-group">
                <label className="f-input-label">{cityLabel}</label>
                <div className="f-select-container">
                  <select
                    className="f-input-profile"
                    id="f-input-city-profile"
                    value={ciudadSelected}
                    onChange={e => setciudadSelected(e.target.value)}
                  >
                    {ciudades.map((ciudad, index) => {
                      return (
                        <option value={ciudad.codigo} key={index}>
                          {ciudad.nombre}
                        </option>
                      )
                    })}
                  </select>
                  <span className="icon-down icon-select"></span>
                </div>
              </div>
            ) : (
                despartamentoSelected !== "" && (
                  <div className="f-input-group">
                    <label className="f-input-label">
                      {cityLabel.toUpperCase()}
                    </label>
                    <div className="f-select-container">
                      <select
                        className="f-input-profile"
                        id="f-input-city-profile"
                        value={ciudadSelected}
                        onChange={e => setciudadSelected(e.target.value)}
                      >
                        <option value="">Selecciona</option>
                        {ciudades
                          .filter(
                            ciu =>
                              ciu.codigoDepartamento === despartamentoSelected
                          )
                          .map((ciudad, index) => {
                            return (
                              <option value={ciudad.codigo} key={index}>
                                {ciudad.nombre}
                              </option>
                            )
                          })}
                      </select>
                      <span className="icon-down icon-select"></span>
                    </div>
                  </div>
                )
              )}
            <div
              className="f-input-group full f-disabled-adress "
              onClick={() =>
                setModalChangeAdress(
                  <ChangeAddress
                    addressDetailValue={addressDetailValue}
                    setaddressDetailValue={setaddressDetailValue}
                    addressValue={addressValue}
                    setaddressValue={setaddressValue}
                    setModalChangeAdress={setModalChangeAdress}
                  />
                )
              }
            >
              <label className="f-input-label">DIRECCIÓN</label>
              <input
                className="f-input-profile"
                type="numeric"
                id="f-input-address-profile"
                value={addressValue}
                onChange={ event => {
                    if (!(/^[ a-zA-Z0-9#°áéíóúÁÉÍÓÚäëïöüÄËÏÖÜñÑ,.;:()¿?¡!_-]+$/).test(event.target.value)) {
                        return false;
                    }else{
                      setaddressValue(event.target.value.replace(/ {2}/g, " "))
                    }
                }}
              />
              {addressError && errorLabel}
            </div>
            <div className="f-input-group f-disabled-update">
              <label className="f-input-label">FECHA DE NACIMIENTO</label>
              <input
                className="f-input-profile"
                type="text"
                value={birthdateValue}
                id="f-input-date-profile"
                onChange={e => setbirthdateValue(e.target.value)}
              />
              <span className="f-icon-tooltip icon-alert">
                <span className="f-tooltip-mail-recovery date-tooltip">
                  ¿Quieres cambiar tu fecha de nacimiento?
                  <a className="f-contact-redirect" href={dateLink}>
                    {process.env.LOCALE === "es-AR" ||
                      process.env.LOCALE === "es-PY"
                      ? "Contactanos"
                      : "Contáctanos"}
                  </a>
                  <span className="f-tooltip-signal"></span>
                  <span className="f-tooltip-bridge" />
                </span>
              </span>
            </div>
            <div className="f-input-group">
              <label
                className="f-title-label"
                onClick={() => {
                  setModalChangeAdress(
                    <OtpModal
                      setCommondModal={setModalChangeAdress}
                      nextFunct={nextToOTPChangePassword}
                    />
                  )
                }}
              >
                Cambiar contraseña
              </label>
            </div>
            <div className="f-input-group full centered f-button-input-group">
              <div
                className={
                  "f-button-container " + (disableButton ? "disabled" : "")
                }
              >
                <Button
                  className="primary-pink short fit regular"
                  title="Guardar cambios"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ProfileModal
